import heroLocal from '../assets/images/hero.webp';
import appPreviewLocal from '../assets/images/app-preview.webp';
import logoLocal from '../assets/images/logo.webp';
import preview0Local from '../assets/videos/preview-0.mp4';
import preview1Local from '../assets/videos/preview-1.mp4';
import preview2Local from '../assets/videos/preview-2.mp4';
import preview3Local from '../assets/videos/preview-3.mp4';
import { SITE_URL } from './seo';

const CDN_BASE = import.meta.env.VITE_CDN_URL?.replace(/\/$/, '');

function cdnUrl(path: string, fallback: string) {
  return CDN_BASE ? `${CDN_BASE}/${path}` : fallback;
}

export const MEDIA = {
  logo: cdnUrl('logo.webp', logoLocal),
  hero: cdnUrl('hero.webp', heroLocal),
  appPreview: cdnUrl('app-preview.webp', appPreviewLocal),
  preview0: cdnUrl('preview-0.mp4', preview0Local),
  preview1: cdnUrl('preview-1.mp4', preview1Local),
  preview2: cdnUrl('preview-2.mp4', preview2Local),
  preview3: cdnUrl('preview-3.mp4', preview3Local),
  thumbnail: cdnUrl('thumbnail.webp', `${SITE_URL}/thumbnail.webp`),
} as const;
